// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"04fa76a5","93":"584ab4e4","169":"a67bbe94","218":"ed3f734f","437":"00c08016","472":"1f65718c","584":"a8aca840","766":"c91d3dcb"}[chunkId] + ".chunk.js";
};